// extracted by mini-css-extract-plugin
export default {"root":"SelectInput_root__Ot-lH","placeholder":"SelectInput_placeholder__z4PK4","icon":"SelectInput_icon__ju0rb","menu":"SelectInput_menu__zJh7z"};